"use client";

import { cn } from "../utils/mergeClassNames";
import { Spinner } from "./spinner";

interface LoadingProps {
  loading?: boolean;
  className?: string;
  fullscreen?: boolean;
}

/**
 * Loading component with spinner.
 * Can be used as fullscreen overlay or inline.
 * When used without props, it renders a fullscreen loading overlay.
 */
function Loading({
  loading = true,
  className,
  fullscreen = true,
}: LoadingProps) {
  if (!loading) return null;

  if (fullscreen) {
    return (
      <div
        role="status"
        aria-label="Loading"
        className={cn(
          "fixed inset-0 z-50 flex items-center justify-center bg-black/30",
          className,
        )}
      >
        <Spinner className="size-10 text-foreground" />
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn("flex items-center justify-center", className)}
    >
      <Spinner className="size-6 text-foreground" />
    </div>
  );
}

export { Loading };
